import { GET_CHATHISTORY } from '../actionTypes';

export default function(state = {}, action) {
    switch (action.type) {
        case GET_CHATHISTORY:
            return action.payload;
        default:
            return state;
    }
}